import { ConstructClassWithPrivateMembers } from '../../../../../../misc/helpers/ClassWithPrivateMembers';
import { FROM_READABLE_STREAM_OBSERVABLE_PRIVATE } from './privates';
import { IsObject } from '../../../../../../helpers';
import { HasFactoryWaterMark } from '../../../../../../classes/class-helpers/factory';
export function ConstructFromReadableStreamObservable(instance) {
    ConstructClassWithPrivateMembers(instance, FROM_READABLE_STREAM_OBSERVABLE_PRIVATE);
}
export function IsFromReadableStreamObservable(value) {
    return IsObject(value)
        && value.hasOwnProperty(FROM_READABLE_STREAM_OBSERVABLE_PRIVATE);
}
export const IS_FROM_READABLE_STREAM_CONSTRUCTOR = Symbol('is-from-iterable-observable-constructor');
export function IsFromReadableStreamObservableConstructor(value) {
    return (typeof value === 'function')
        && HasFactoryWaterMark(value, IS_FROM_READABLE_STREAM_CONSTRUCTOR);
}
//# sourceMappingURL=constructor.js.map